import React, {useEffect, useState} from 'react'
import Text from '../../../components/text/Text'
import useQueryWalletTransactionsDetail from '../../../hooks/api/wallets/useQueryWalletTransactionsDetail'
import WizPagination from '../../../components/pagination/WizPagination'
import TableHeader from '../../../components/table/TableHeader'
import TableItem from '../../../components/table/TableItem'
import Span from '../../../components/text/Span'

interface IProps {
    className?: string
    userID?: string
}

const WalletsTransactionContainer: React.FC<IProps> = ({className, userID}) => {
    const [currentPage, setCurrentPage] = useState(1)
    const {data: wtxData, refetch} = useQueryWalletTransactionsDetail(userID, currentPage)

    useEffect(() => {
        refetch()
    }, [currentPage])

    return (
        <div className={`bg-white rounded-[10px] p-[30px] ${className}`}>
            <Text className={'text-h3'}>Wallet Transactions</Text>
            <div className={'mt-[30px]'}>
                <TableHeader className={`grid-cols-4 sm:hidden`}>
                    <Text className={''}>Action</Text>
                    <Text className={''}>Amount</Text>
                    <Text className={''}>After Balance</Text>
                    <Text className={''}>Date</Text>
                </TableHeader>
                {wtxData?.data?.map(el => (
                    <div className="relative">
                        <TableItem className={`grid-cols-4 sm:block sm:space-y-[5px]`}>
                            <div className={'space-y-[5px] break-words whitespace-normal'}>
                                <Text className={'text-ti2'}>{el.action}</Text>
                            </div>
                            <div className={'space-y-[5px] break-words whitespace-normal'}>
                                <Text className={'sm:text-ti2'}>
                                    <Span className={'hidden sm:inline sm:text-body2'}>Amount : </Span>
                                    {el.amount} {el.coin}
                                </Text>
                            </div>
                            <div className={'space-y-[5px] break-words whitespace-normal'}>
                                <Text className={'sm:text-ti2'}>
                                    <Span className={'hidden sm:inline sm:text-body2'}>After Balance : </Span>
                                    {el.balance_after} {el.coin}
                                </Text>
                            </div>
                            <div className={'space-y-[5px] break-words whitespace-normal'}>
                                <Text className={'sm:text-body3 sm:text-font03'}>
                                    <Span className={'hidden sm:inline'}>Date : </Span>
                                    {new Date(el.created_at).toLocaleString()}
                                </Text>
                            </div>
                        </TableItem>
                    </div>
                ))}
            </div>
            <WizPagination
                totalPage={wtxData?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => {
                    setCurrentPage(item)
                }}
                isScrollTop={false}
            />
        </div>
    )
}

export default WalletsTransactionContainer
